import React from 'react';
import PropTypes from 'prop-types';
import colors from 'hsl-shared-components/lib/Theme/colors';
import styled from 'styled-components';
import {
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_BREAKPOINT_IN_PX,
} from '../../constants';

const Button = styled.a`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 14px 28px;
  width: fit-content;
  height: 50px;
  background: #fffff;
  border: 1px solid #888888;
  border-radius: 50px;
  font-size: 18px;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    font-size: 14.5px;
    line-height: 16px;
    letter-spacing: -0.5px;
    padding: 13px 0;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    font-size: 16px;
    letter-spacing: -0.5px;
    padding: 12px 0;
    line-height: 16px;
  }

  &:hover {
    cursor: pointer;
    background: ${colors.primary.hslWhite};
    border-color: ${colors.primary.hslBlueDark};
  }

  &:hover div {
    color: ${colors.primary.hslBlueDark};
  }
`;

const TextWrapper = styled.div`
  font-weight: 400;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: ${colors.primary.hslBlue};

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    padding: 0 28px 0 28px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    padding: 0 28px 0 28px;
  }
`;

const IconButton = ({ onClick, text }) => (
  <Button onClick={onClick}>
    <TextWrapper>{text}</TextWrapper>
  </Button>
);

IconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default IconButton;
